import { useQuery } from '@tanstack/react-query';

import { newsApi } from '@/services';

export const dashboardKeys = {
  data: ['admin', 'dashboard', 'data'] as const,
};

export function useDashboardDataQuery() {
  return useQuery({
    queryKey: dashboardKeys.data,
    queryFn: async () => {
      const newsData = await newsApi.getAll(1, 5);

      return {
        newsData,
      };
    },
  });
}
